'use strict';

import { environment } from '@quartz-iam-legacy/environments/environment';

angular.module('supervisorAuthorizingUserRequestControllers')

.factory('supervisorAuthorizingUserRequestService', ['$http', '$q', function ($http, $q) {

    var service = {};

    var baseUrl = environment.apiUrl + '/ID/API/Supervisor/AuthorizingUserRequest';

    // **** HttpGet

    service.getUserRequestToAuthorize = function (userAccessRequestId) {
        return $http.get(baseUrl + '/UserRequest/' + userAccessRequestId, {})
                    .then(function (response) {
                        return response.data;
                    });
    }

    // **** HttpPost

    service.authorize = function (userAccessRequestId, systemRoleIdsToCancel) {
        return $http.post(baseUrl + '/UserRequest/' + userAccessRequestId +
                          '/Authorize', { systemRoleIds: systemRoleIdsToCancel })
                    .then(function (response) {
                        return response.data;
                    });
    }

    return service;
}]);
